import { Reducer as Reducer_ } from 'redux';
import * as types from '../actions/actionTypes/loading';
import { ILoadingActionType as ILoadingActionType_ } from '../actions/loading-actions';

const loadingReducer: Reducer_<boolean, ILoadingActionType_> = (state = false, { type, payload, }) => {
  switch (type) {
    case types.FETCHING_STARTED:
    case types.FETCHING_ENDED:
      return payload;
    default:
      return state;
  }
};

export default loadingReducer;
